import React from 'react';
import {Navigate} from 'react-router-dom';
import * as consts from '../../utils/constants';

function NavigatePropertiesFeature() {
  return <Navigate to={consts.SLUG_PROPERTIES} />;
}

export default NavigatePropertiesFeature;
